module.exports = __webpack_public_path__ + "static/media/image_22.be47cecb.png";